import {
    GET_ADV_BUDGET_PERFORMANCE_LOADING,
    GET_ADV_BUDGET_PERFORMANCE_SUCCESS

} from '../actions/AdvBudgetPerformanceActions';

const initialState = {
    advBudgetPerformanceData: null,
    isLoading: true,
};

const advBudgetPerformanceReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case GET_ADV_BUDGET_PERFORMANCE_SUCCESS:
            return { ...state, advBudgetPerformanceData: action.data, isLoading: false };

        case GET_ADV_BUDGET_PERFORMANCE_LOADING:
            return { ...state, isLoading: action.isLoading };

        default:
            return state;
    }
};

export default advBudgetPerformanceReducer;
